@if (type() === 'create-new') {
  <create-rob-report (save)="onSaveCreate()" (close)="onClose()" />
} @else if (type() === 'details') {
  <rob-report-details (close)="onClose()" />
}
